import React from 'react';
import { DateInput as RaDateInput } from 'react-admin';
import { DateInput } from 'react-admin-date-inputs';

export const FormattedDateInput: typeof RaDateInput = props => (
	<DateInput {...props} options={{ format: 'yyyy-MM-dd', clearable: true }} />
);
